import Link from 'next/link';
import { Helmet } from 'react-helmet';

import Layout from 'components/Layout';
import Section from 'components/Section';
import Container from 'components/Container';

import styles from 'styles/pages/404.module.scss';
import useSite from 'hooks/use-site';

function _render(code) {
    const { locale } = useSite()
    const lang = locale.toLowerCase()
    if (code === 404) {
        return (
            <Layout isFullColor={true}>
            <Helmet>
                <title>404 | {lang === 'th' ? `ไม่พบหน้าที่คุณกำลังค้นหา` : `Page not found`}</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Section className={styles.sectionWrapper}>
                <Container className={styles.center}>
                <h1>404 {lang === 'th' ? `ไม่พบหน้านี้` : `Page not found`}</h1>
                <span>{lang === 'th' ? `ไม่พบหน้าที่คุณกำลังค้นหา` : `The page you were looking for could not be found.`}</span>
                <p>
                    <Link href={lang === 'th' ? '/th' : '/'}>
                        <a>{lang === 'th' ? `กลับไปหน้าแรก` : `Go back home`}</a>
                    </Link>
                </p>
                </Container>
            </Section>
            </Layout>
        )
    } else if (code === 403) {
        return (
            <Layout isFullColor={true}>
            <Helmet>
                <title>403 | {lang === 'th' ? `ไม่สามารถเข้าถึง` : `Unauthorized`}</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Section className={styles.sectionWrapper}>
                <Container className={styles.center}>
                <h1>403 {lang === 'th' ? `ไม่สามารถเข้าถึง` : `Unauthorized`}</h1>
                <span>{lang === 'th' ? `ไม่พบหน้าที่คุณกำลังค้นหา` : `The page you were looking for could not be found.`}</span>
                <p>
                    <Link href={lang === 'th' ? '/th' : '/'}>
                        <a>{lang === 'th' ? `กลับไปหน้าแรก` : `Go back home`}</a>
                    </Link>
                </p>
                </Container>
            </Section>
            </Layout>
        )
    } else {
        <Layout isFullColor={true}>
        <Helmet>
            <title>{lang === 'th' ? `เกิดข้อผิดพลาดกับไคลเอนต์` : `An error occurred on client`}</title>
            <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <Section className={styles.sectionWrapper}>
            <Container className={styles.center}>
            <h1>{lang === 'th' ? `เกิดข้อผิดพลาดกับไคลเอนต์` : `An error occurred on client`}</h1>
            <span>{lang === 'th' ? `ไม่พบหน้าที่คุณกำลังค้นหา` : `The page you were looking for could not be found.`}</span>
            <p>
                <Link href="/">
                    <a>{lang === 'th' ? `กลับไปหน้าแรก` : `Go back home`}</a>
                </Link>
            </p>
            </Container>
        </Section>
        </Layout>
    }
}

function Error({ statusCode }) {
    return (_render(statusCode))
}
  
Error.getInitialProps = ({ res, err }) => {
    const statusCode = res ? res.statusCode : err ? err.statusCode : 404
    return { statusCode }
}
  
export default Error